import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../../actions";
import { IsResponseValidUtil } from "../../utils/api-utils";
import trafficCamGeoData from "../../assets/trafficCamGeo.json";
import getCamerasResponse from "../../assets/trafficCamWsdotGetCamerasResponse-2026-03-16.json";

// const TRAFFIC_CAM_URL = process.env.REACT_APP_CAMERA_FEED_URL;

type WsdotCamera = {
  CameraID: number,
  CameraLocation: {
      Description: null,
      Direction: string | null,
      Latitude: number;
      Longitude: number;
      MilePost: number;
      RoadName: string;
  },
  CameraOwner: string | null,
  Description: string | null;
  DisplayLatitude: number;
  DisplayLongitude: number;
  ImageHeight: number;
  ImageURL: string;
  ImageWidth: number;
  IsActive: boolean;
  OwnerURL: string | null;
  Region: string;
  SortOrder: number;
  Title: string;
}

function transformWsdotCameraDataToFeatures(): GeoJSON.FeatureCollection<GeoJSON.Geometry> {
  const wsdotCameras: WsdotCamera[] = getCamerasResponse;
  const wsdotCamerasFeatures: GeoJSON.FeatureCollection<GeoJSON.Geometry> = {
    type: "FeatureCollection",
    features: wsdotCameras.map((c) => {
      return {
        type: "Feature",
        properties: {
          OBJECTID: c.CameraID,
          COMPKEY: null,
          //UNITID: "",
          OWNERSHIP: c.CameraOwner,
          DISTRICT: null,
          NAME: c.ImageURL.substring(c.ImageURL.lastIndexOf("/") + 1),
          COMPTYPE: 16,
          URL: c.ImageURL,
          LOCATION: c.Title,
          SERVSTAT: c.IsActive ? "ACTV" : "",
        },
        "geometry": {
          type: "Point",
          coordinates: [c.DisplayLongitude, c.DisplayLatitude],
        }
      }
    })
  };

  return wsdotCamerasFeatures;
} 

export function* getGeoJson(action: any): Generator<any, void, unknown> {
  try {
    console.log("getGeoJson start");
    
    const wsdotCamerasFeatures = transformWsdotCameraDataToFeatures();
    const allCamerasFeatures = new Map<string, GeoJSON.Feature<GeoJSON.Geometry, GeoJSON.GeoJsonProperties>>(
      wsdotCamerasFeatures.features.map(i => [i.properties?.URL as string, i]),
    );

    // TODO: Update to pull from API vs stored file
    // @ts-ignore
    const result: GeoJSON.FeatureCollection<GeoJSON.Geometry> = trafficCamGeoData;
    // const result: any = yield call(api.getGeoJsonFile, action.payload.sourceUrl);
    if (result) {
      if (IsResponseValidUtil(result)) {
        let apiResultPayload: GeoJSON.FeatureCollection<GeoJSON.Geometry> = result;
        const trafficCamGeoCount = apiResultPayload.features.length;
        const wsdotCount = wsdotCamerasFeatures.features.length;
        let deduplicatedCount = 0;

        // Use the Map to eliminate duplicates
        apiResultPayload.features.forEach((f) => {
          if(!allCamerasFeatures.has(f.properties?.URL)) {
            allCamerasFeatures.set(f.properties?.URL, f);
          } else {
            //console.log("Camera not added: ", f.properties?.URL);
            deduplicatedCount++;
          }
        });

        // Update payload after deduplication
        apiResultPayload.features = [...allCamerasFeatures.values()];
        let finalCount = apiResultPayload.features.length;

        console.log("Legacy:", trafficCamGeoCount, "WSDOT:", wsdotCount, "Duplicates:", deduplicatedCount, "Final count:", finalCount);

        yield put(actions.getGeoJsonSuccess(apiResultPayload));
      }
    } else {
      yield put(actions.getGeoJsonFailure("Error fetching traffic camera geoJson"));
    }
  } catch (e) {
    //TODO: Implement proper logging and error handling
    yield put(actions.getGeoJsonFailure("Error fetching traffic camera geoJson"));
    console.log(e);
  }
}
function* watchGeoJsonEvent() {
  yield takeEvery(actions.types.GET_TRAFFIC_CAM_GEO_JSON, getGeoJson);
}

const geoJsonSagas = [fork(watchGeoJsonEvent)];

export default geoJsonSagas;
